import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  HAS_LOGGED_IN = 'hasLoggedIn';
  private USER_ROLE = 'userRole';
  private currentUserRole = new BehaviorSubject<any>(null);

  constructor(
    private translate: TranslateService,
    public storage: Storage,
    private apiService: ApiService) {}

  login(username: string, userRole?: string): Promise<boolean> {
    return this.storage.set(this.HAS_LOGGED_IN, true).then(() => {
      this.setUsername(username);
      this.currentUserRole.next(userRole);
      return window.dispatchEvent(new CustomEvent('user:login'));
    });
  }

  signup(username: string): Promise<boolean> {
    return this.storage.set(this.HAS_LOGGED_IN, true).then(() => {
      this.setUsername(username);
      return window.dispatchEvent(new CustomEvent('user:signup'));
    });
  }

  logout(): Promise<any> {
    return this.storage
      .remove(this.HAS_LOGGED_IN)
      .then(() => {
        this.storage.remove(this.USER_ROLE);
        this.currentUserRole.next(null);
        return this.storage.remove('username');
      })
      .then(() => {
        window.dispatchEvent(new CustomEvent('user:logout'));
      });
  }

  setUsername(username: string): Promise<any> {
    return this.storage.set('username', username);
  }

  setLocalUserRole(userRole: string): Promise<any> {
    return this.storage.set('userRole', userRole);
  }

  getLocalUserRole(): Promise<string> {
    return this.storage.get('userRole').then(value => {
      return value;
    });
  }

  isLoggedIn(): Promise<boolean> {
    return this.storage.get(this.HAS_LOGGED_IN).then(value => {
      return value === true;
    });
  }

  getUserRoleFromApi(): Observable<any> {
    return this.apiService.apiGet('users/current-user')
      .pipe(
        tap(user => {
          const impersonationState = window.localStorage.getItem('impersonationState');
          if (impersonationState === null) {
            const lang = user.languagePreference || 'en';
            window.localStorage.setItem('languagePreference', lang);
            this.translate.use(lang);
          }
        })
      );
  }
}
